var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDashboard = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dashboard_FILL0_wght400_GRAD0_opsz48",
    d: "M17.917,14.25V6H28v8.25ZM6,17.917V6H16.083V17.917ZM17.917,28V16.083H28V28ZM6,28V19.75H16.083V28ZM7.833,16.083H14.25V7.833H7.833ZM19.75,26.167h6.417v-8.25H19.75Zm0-13.75h6.417V7.833H19.75ZM7.833,26.167H14.25V21.583H7.833ZM14.25,16.083ZM19.75,12.417ZM19.75,17.917ZM14.25,21.583Z",
    transform: "translate(-6 -6)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDashboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dashboard.7c3da945.svg";
export { ForwardRef as ReactComponent };